import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Spin, Carousel, FloatButton } from 'antd';
import WonderGameSlider from '../components/WonderGameSlider';
import Loader from '../components/Loader';
import { useParams, useNavigate } from 'react-router-dom';



const YanchaWonderGame = () => {
    const [gamepagedata, setGamepagedata] = useState([])
    const [loading, setLoading] = useState(true)
    const [link, setLink] = useState("")

    const navigate = useNavigate();


    useEffect(() => {
        getGamedata()
    }, []);

    const getGamedata = () => {
        axios.get('pages/81?acf_format=standard')
            .then((response) => {
                // console.log(response)
                setGamepagedata(response.data)
                setLoading(false)
                setLink(response.data.acf.buy_url_game)
            })
    }

    const buyNow = () => {
        console.log(link)
        // navigate(link)
        window.location.href = link;
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        }, 700);
    }

    return (
        <div>
            {
                loading ? <Loader /> :
                    <>
                        <FloatButton onClick={() => console.log('onClick')} />
                        {/* page heading */}
                        <div className='spacer'>
                            <p className='large-gradient-heading brand-text'>{gamepagedata.title.rendered}</p>
                        </div>

                        <div className='spacer'>
                            <p className='brand-text txt-survey'>{gamepagedata.acf.extract_game}</p>
                        </div>

                        <div className='flex h-1/2 justify-center spacer'>
                            {
                                (link === "") ?
                                    <button disabled className='p-4 rounded bg-gray-300' onClick={() => buyNow()}>
                                        <p className='txt brand-font'>Coming Soon</p>
                                    </button>
                                    :
                                    <button className='p-4 rounded bg-green-500' onClick={() => buyNow()}>
                                        <p className='txt-inverse small-heading brand-font'>BUY NOW</p>
                                    </button>
                            }
                        </div>

                        {/* highlights */}
                        <div className='spacer'>
                            <div className='border-gray-100 border-[2px] rounded p-[5px] bottom15px'>
                                <div className='grid grid-cols-2 gap-4 bottom7px'>
                                    <div className='flex items-center'>
                                        <p className='brand-text text-[15px]'>{gamepagedata.acf.with_friends_writeup_game}</p>
                                    </div>
                                    <div>
                                        <img src={gamepagedata.acf.with_friends_image_game} alt={gamepagedata.acf.with_friends_heading_game} className='rounded' />
                                    </div>
                                </div>
                                <div>
                                    <p className='brand-text small-heading text-center padding7px'>{gamepagedata.acf.with_friends_heading_game}</p>
                                </div>
                            </div>

                            <div className='border-gray-100 border-[2px] rounded p-[5px]'>
                                <div className='grid grid-cols-2 gap-4 bottom7px'>
                                    <div>
                                        <img src={gamepagedata.acf.alone_image_game} alt={gamepagedata.acf.alone_heading_game} className='rounded' />
                                    </div>
                                    <div className='flex items-center'>
                                        <p className='brand-text text-[15px]'>{gamepagedata.acf.alone_writeup_game}</p>
                                    </div>
                                </div>
                                <div>
                                    <p className='brand-text small-heading text-center padding7px'>{gamepagedata.acf.alone_heading_game}</p>
                                </div>
                            </div>
                        </div>

                        {/* slider */}
                        <div className='bottom15px'>
                            <p className='brand-text gradient-heading'>{gamepagedata.acf.benefits_heading_game}</p>
                        </div>

                        {/* slides */}
                        <div className='bottom15px'>
                            <WonderGameSlider features={gamepagedata.acf.benefits_items_game} />
                        </div>

                        {/* benefits */}
                        <div className='grid grid-cols-2 gap-4 bottom15px'>
                            <div>
                                <img src={gamepagedata.acf.benefits_section_one_image_game} alt={gamepagedata.acf.benefits_section_one_heading_game} className='rounded' />
                                <p className='text-center brand-font text-[14px]'>{gamepagedata.acf.benefits_section_one_heading_game}</p>
                            </div>
                            <div>
                                <img src={gamepagedata.acf.benefits_section_two_image_game} alt={gamepagedata.acf.benefits_section_two_heading_game} className='rounded' />
                                <p className='text-center brand-font text-[14px]'>{gamepagedata.acf.benefits_section_two_heading_game}</p>
                            </div>
                        </div>

                        <div>
                            <p className='brand-text txt-survey'>{gamepagedata.acf.benefits_excerpt_game}</p>
                        </div>

                    </>
            }

        </div>
    )
}

export default YanchaWonderGame